import React from "react";
import { Alert, Card, Col, Row, Table, Badge, Image } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ModuleDisplayDate from "../../../../UI/modules/fieldsDisplay/ModuleDisplayDate";
import ModuleDisplayDateTime from "../../../../UI/modules/fieldsDisplay/ModuleDisplayDateTime";
import ModuleDisplayEmail from "../../../../UI/modules/fieldsDisplay/ModuleDisplayEmail";
import ModuleDisplayFieldsController from "../../../../UI/modules/fieldsDisplay/ModuleDisplayFieldsController";
import ModuleDisplayPhone from "../../../../UI/modules/fieldsDisplay/ModuleDisplayPhone";
import memberDummyImage from "../../../../../images/memberDummyImage.jpg";
import memberStatusEmailVerificationRequired from "../../../../../images/memberStatusEmailVerificationRequired.png";
import memberStatusSignupRequest from "../../../../../images/memberStatusSignupRequest.png";
import memberStatusRejected from "../../../../../images/memberStatusRejected.png";
import memberStatusRegistrationPaymentPending from "../../../../../images/memberStatusRegistrationPaymentPending.png";
import memberStatusMember from "../../../../../images/memberStatusMember.jpg";
import ModuleDisplayBoolean from "../../../../UI/modules/fieldsDisplay/ModuleDisplayBoolean";
import StatsListing from "../../../../UI/shared/infoListing/StatsListing";
import { getCurrencyCode } from "../../../../../helpers/CommonHelper";

const Item = ({
  item,
  moduleConfig,
  confirmAndStop,
  confirmAndStart,
}) => {
  const fields = moduleConfig.fields;
  const getItems = () => {
    let items = [];
    if (item.target) {
      items = [...items, { text: "Target", value: item.target, type: "text" }];
    }

    if (item.resultType) {
      items = [...items, { text: "Show Results On", value: item.resultType, type: "text" }];
    }

    if (item.target && (item.target !== "All-Members" && item.target !== 'Attach-to-Activity')) {
      items = [
        ...items,
        {
          text:
            "Target " +
            (item.target === "Selected-Circles"
              ? " Circles "
              : item.target === "Selected-Members"
                ? " Members "
                : null) +
            "Count",
          value:
            item.target === "Selected-Circles"
              ? item.targetedCirclesCount
                ? item.targetedCirclesCount
                : "Targets not added yet"
              : item.target === "Selected-Members"
                ? item.targetedMembersCount
                  ? item.targetedMembersCount
                  : "Targets not added yet"
                : 0,
          type: "text",
        }
      ];
    }

    if (item.activityId) {
      items = [
        ...items,
        {
          text: "Attached Activity",
          value: item.attachedActivity.title,
          type: "text"
        }
      ];
    }


    return items;
  };
  return (
    <Card className="item mb-2">
      <Card.Header className="ps-1 pe-2 py-0">
        <Card.Title className="d-flex m-0 p-0">
          <div className="d-flex ImageSectionSpacing">

            <div className="ms-1 me-2 ">
              <i className="fas fa-poll position-relative usericon ">
                {(item.status === "disabled") && (
                  <i className="fas fa-ban position-absolute banned3"></i>
                )}
              </i>
            </div>

            <div className={'ms-1 d-flex flex-column'}>
              <span className="m-0 text-bold memberName">{item.title}  {item.isAnnounced === "1" && <span className="result-announced"> (<i class="fa fa-trophy mx-1" aria-hidden="true"></i>
                Result Announced )</span>}</span>

              <span className=" font-small font-weight-normal text-success fs-6 mt-1 ">
                <span className="cutsomText-red">
                  Total Questions - {item.questionsCount}
                </span>
              </span>
            </div>
          </div>
        </Card.Title>

        <div class="card-tools mb-1">
          <div>
            {(item.status === "disabled") && (
              <span className="badge badge-secondary me-1 text-white">
                Disabled
              </span>
            )}
            {(item.status === "notStarted") && (
              <span className="badge badge-dark  me-1 text-white">
                Not Started
              </span>
            )}
            {(item.status === "begun") && (
              <span className="badge badge-success  me-1 text-white">
                Begun
              </span>
            )}
            {(item.status === "finished" && item.isAnnounced === "0") && (
              <span className="badge badge-info  me-1 text-white">
                Finished
              </span>
            )}

            {(item.status === "finished" && item.isAnnounced === "1") && (
              <span className="badge badge-primary  me-1 text-white">
                Results Announced
              </span>
            )}

            {(item.status === "archived") && (
              <span className="badge badge-warning  me-1 text-dark">
                Archived
              </span>
            )}


            <span class="badge badge-light me-1 text-dark">
              Created Date/Time :{" "}
              <span class="text-secondary">
                <ModuleDisplayDateTime value={item.createdAt} />{" "}
              </span>
            </span>
          </div>

          <div className=" text-right me-xl-2  mt-1">
            <Link
              to={`/${moduleConfig.url}/${item._id}`}
              className="btn btn-outline-secondary  listingActionIcon"
              title="View Item details"
            >
              <i className="fas fa-eye"></i>
            </Link>

            <Link
              to={`/${moduleConfig.url}/update/${item._id}`}
              className="btn btn-outline-secondary listingActionIcon"
              title="Update Item"
            >
              <i className="fas fa-pencil-alt"></i>
            </Link>

            {(item.status === "begun") && (
              <span
                title="Finish Poll"
                onClick={() => confirmAndStop(item._id)}
                className="btn btn-outline-secondary  listingActionIcon"
              >
                <i className="fas fa-stop"></i>
              </span>
            )}

            {(item.status === "finished") && (
              <span
                title="Start Poll"
                onClick={() => confirmAndStart(item._id)}
                className="btn btn-outline-secondary listingActionIcon"
              >
                <i className="fas fa-play"></i>
              </span>
            )}
          </div>
        </div>
      </Card.Header>
      <Card.Body className="p-2">
        <StatsListing items={getItems()} />
        {console.log(item)}
        {item.submissionsCount &&
          <StatsListing
            border="border"
            heading="Stats"
            clickable={true}
            items={[
              {
                title: "Submissions Count",
                value: item.submissionsCount,
                url: `/poll-submissions/${item._id}`,
              },

            ]}
          />}
        <Link
          class="btn btn-sm btn-outline-primary  listingActionIcon"
          title="View Item details"
          to={`/poll-submissions/${item._id}`}
        >
          <i class="fas fa-list"></i> &nbsp; View Submission(s)
        </Link>

        <Link
          class="btn btn-sm btn-outline-primary  listingActionIcon ml-1"
          title="View Item details"
          to={`/poll-stats/${item._id}`}
        >
          <i class="fas fa-chart-bar"></i> &nbsp; View Stats
        </Link>
      </Card.Body>
    </Card>
  );
};

export default Item;
